// Customer reviews shown in the scrolling testimonials band.
//
// These are SAMPLE placeholders — replace them with your real Google / Yelp
// reviews before publishing (keep 6+ for a full scrolling row). Edit here;
// the component picks them up automatically.

export interface Review {
  quote: string;
  author: string;
  meta: string; // location or context
  source: 'Google' | 'Yelp' | 'Uber Eats' | 'DoorDash';
  rating: number; // 1–5
  verified?: boolean;
}

export const REVIEWS: Review[] = [
  { quote: 'The Hyderabadi dum biryani is the real deal — fragrant, perfectly spiced, and the mutton falls off the bone.', author: 'Aisha R.', meta: 'Irving, TX', source: 'Google', rating: 5 },
  { quote: 'Al Faham mandi for the family and everyone went quiet. Smoky, tender, generous portions. We’ll be back weekly.', author: 'David M.', meta: 'Local Guide · 42 reviews', source: 'Google', rating: 5 },
  { quote: 'Dosas as crisp as the ones back home. The chutneys alone are worth the drive to Valley Ranch.', author: 'Priya S.', meta: 'Coppell, TX', source: 'Yelp', rating: 5 },
  { quote: 'Chicken 65 and lollipops were fire — literally the best starters I’ve had in DFW. Fast, friendly service too.', author: 'Marcus T.', meta: 'Google review', source: 'Google', rating: 5 },
  { quote: 'Finally a place that does South Indian AND Arabian mandi and nails both. The paneer tikka mandi is unreal.', author: 'Sneha K.', meta: 'Las Colinas', source: 'Google', rating: 5 },
  { quote: 'Huge menu, everything fresh. The shawarma platter and the falooda made it a perfect meal. Highly recommend.', author: 'Omar H.', meta: 'Uber Eats', source: 'Uber Eats', rating: 5 },
  { quote: 'Ordered the King Mandi for a birthday — showstopper on the table and even better to eat. Great value for a crowd.', author: 'Lauren P.', meta: 'Irving, TX', source: 'Google', rating: 5 },
  { quote: 'Warm hospitality, clean space, and biryani that actually smells like biryani. This is my new go-to.', author: 'Raj V.', meta: 'Local Guide', source: 'Google', rating: 5 },
];

export const RATING_SUMMARY = {
  average: Number((REVIEWS.reduce((sum, r) => sum + r.rating, 0) / REVIEWS.length).toFixed(1)),
  count: REVIEWS.length,
  detail: REVIEWS.reduce((acc, r) => {
    acc[r.rating] = (acc[r.rating] || 0) + 1;
    return acc;
  }, {} as Record<number, number>),
};
